module.exports = __webpack_public_path__ + "static/media/14UNEP6.ebe0fd30.jpg";